// src/sections/DacheindeckungSection.jsx
import React from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { showSuccess, showError } from "../utils/toastUtils";
import { Box, Button } from "@chakra-ui/react";


export default function DacheindeckungSection({ selectedAnlageId }) {
  const options = ["Ziegel", "Faserzement", "Metall", "Bitumen", "Folie"];

  const [checkedValues, setCheckedValues] = useState([]);

  useEffect(() => {
    if (!selectedAnlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/dacheindeckung/anlage/${selectedAnlageId}`)
      .then((res) => {
        const data = res.data;
        const loaded = [];

        if (data.ziegel) loaded.push("Ziegel");
        if (data.metall) loaded.push("Metall");
        if (data.bitumen) loaded.push("Bitumen");
        if (data.folie) loaded.push("Folie");
      if (data.faserzement) loaded.push("Faserzement");

        setCheckedValues(loaded);
      })
      .catch(() => setCheckedValues([]));
  }, [selectedAnlageId]);

  const handleSave = async () => {
    const checked = checkedValues;

    const payload = {
      anlage: { id: selectedAnlageId },
      ziegel: checked.includes("Ziegel"),
       faserzement: checked.includes("Faserzement"),
      metall: checked.includes("Metall"),
      bitumen: checked.includes("Bitumen"),
      folie: checked.includes("Folie"),
    };

    try {
      // try load existing
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/dacheindeckung/anlage/${selectedAnlageId}`
      );

      // update
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/dacheindeckung/${res.data.id}`,
        payload
      );

      showSuccess("Gespeichert", "Dacheindeckung wurde aktualisiert");
    } catch {
      // create
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/dacheindeckung`,
        payload
      );

      showSuccess("Gespeichert", "Dacheindeckung wurde gespeichert");
    }
  };

  return (
        <Box 
          p={8} 
          bg="white" 
          borderRadius="xl" 
          boxShadow="md" 
          mt={6} 
          mb={10} 
          maxW="fit-content"
        >
      <h3
        style={{
          marginBottom: 16,
          color: "#000000",
          fontWeight: "700",
          textTransform: "uppercase",
          marginLeft: 0,
          fontSize: "24px"
        }}
      >
        DACHEINDECKUNG
      </h3>

      <div
        style={{
          background: "#f7fafc",
          padding: 16,
          borderRadius: 8,
          display: "grid",
          gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
          gap: 12,
        }}
      >
        {options.map((opt) => (
          <label
            key={opt}
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <input
              type="checkbox"
              value={opt}
              checked={checkedValues.includes(opt)}
              onChange={(e) =>
                setCheckedValues((prev) =>
                  e.target.checked
                    ? [...prev, opt]
                    : prev.filter((v) => v !== opt)
                )
              }
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <Button
        type="button"
         bg="#B8860B"
         _hover={{ bg: "#C99414" }}
        size="lg"
        width="fit-content" 
        onClick={handleSave}
      >
        Speichern Dacheindeckung
      </Button>
        </Box>
  );
}